const AwsExports = {
  graphqlEndpoint: process.env.REACT_APP_GRAPHQL_ENDPOINT,
  region: process.env.REACT_APP_APPSYNC_REGION,
  authenticationType: process.env.REACT_APP_AUTHENTICATION_TYPE,
  apiKey: null
};

export default AwsExports;
